import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=9e873468&scoped=true"
import script from "./CountryItem.vue?vue&type=script&lang=js"
export * from "./CountryItem.vue?vue&type=script&lang=js"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=9e873468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e873468",
  null
  
)

export default component.exports